import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import { JOB_PORTAL_KEYS, NS } from '../../../../../i18n/constants/keys';
import type { IApplySectionProps } from '../../interfaces';

export const ApplySection = ({ onApplyClick }: IApplySectionProps) => {
  const { t } = useTranslation(NS.jobPortal);

  return (
    <Box sx={{ mb: 2, borderRadius: 2, bgcolor: 'primary.main', color: 'primary.contrastText', p: 2.5, textAlign: 'center' }}>
      <Typography variant="h3" color="inherit" sx={{ mb: 1 }}>
        {t(JOB_PORTAL_KEYS.apply.readyToApply)}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, opacity: 0.85 }}>
        {t(JOB_PORTAL_KEYS.apply.joinTeam)}
      </Typography>
      <Button
          onClick={onApplyClick}
          variant="contained"
          fullWidth
          sx={{
            bgcolor: 'background.paper',
            color: 'primary.main',
            '&:hover': { bgcolor: 'grey.100' },
          }}
      >
        {t(JOB_PORTAL_KEYS.apply.applyNow)}
      </Button>
    </Box>
  );
};
